import Vue from 'vue'

// Plugins
import Cashback from 'cashback-api-js'
const cashback = new Cashback()
Vue.prototype.$cashback = cashback

import VueCardFormat from 'vue-credit-card-validation'
Vue.use(VueCardFormat)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultTrigger: 'hover focus click'
})
// Styles and scripts
import './js/base.js'

// Components
import App from 'Components/App.vue'
import Account from 'Components/Templates/Account.vue'
import Auth from 'Components/Templates/Auth.vue'
import ClaimCashback from 'Components/Partials/ClaimCashback'



Vue.component('app', App)
Vue.component('account', Account)
Vue.component('auth', Auth)
Vue.component('claim-cashback', ClaimCashback)


// Global filters
Vue.filter('localizeCurrency', function (value) {
  if (!value && value !== 0) return value
  return new Intl.NumberFormat('da-DK', { style: 'currency', currency: 'DKK' }).format(value)
})

Vue.filter('normalizeBalance', function (value) {
  return (value < 1 && value >= 0) ? 0 : value
})

Vue.filter('formatDate', function (value) {
  if (!value) return value
  var getDate = new Date(value)
  return ('0' + getDate.getDate()).slice(-2) + "-" + ('0' + (getDate.getMonth() + 1)).slice(-2) + "-" + getDate.getFullYear();
})

// Global methods
Vue.mixin({
  methods: {
    formatAmount(value) {
      if (!value) return value
      if (this.$settings.pointsEnable) {
        return '<span>' + Math.floor(parseFloat(value) * parseInt(this.$settings.pointsConversionRate)) + '</span>' + ' point'
      } else {
        return this.$options.filters.localizeCurrency(value)
      }
    },
  },
})

// Boot
const apps = Object.entries(document.getElementsByClassName('cashback-app'))

if (apps.length) {
  for (const [key, app] of apps) {
    new Vue({
      el: app
    })
  }
}
